import { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import { ThreadResponseStatus } from "~frontend/__generated__/graphql";

export function ThreadResponseStatusLabel({
  responseStatus,
}: {
  responseStatus: ThreadResponseStatus;
}): ReactElement {
  switch (responseStatus) {
    case ThreadResponseStatus.HasRepliedNeedsResponse:
      return (
        <FormattedMessage
          defaultMessage="Needs Response"
          description="Filter for threads that need a response"
        />
      );
    case ThreadResponseStatus.HasRepliedDoesntNeedResponse:
      return (
        <FormattedMessage
          defaultMessage="Has Replied, Does Not Need Response"
          description="Filter for threads that have replies but don't need a response"
        />
      );
    case ThreadResponseStatus.NoReply:
      return (
        <FormattedMessage
          defaultMessage="Has Not Replied"
          description="Filter for threads that have no replies"
        />
      );
  }
}
